import { ReactComponent as BusinessCartSvg } from '../../assets/images/business-cart.svg';

export const BusinessCartIcon: SvgIcon = (props) => {
    return <BusinessCartSvg {...props} />;
};
